import { pageRoute } from "../routeFactory";

const HomePage = () => import("@/views/HomePage.vue");
const ForewordPage = () => import("@/views/ForewordPage.vue");
const MissionPage = () => import("@/views/MissionPage.vue");
const VisionPage = () => import("@/views/VisionPage.vue");
const OverviewPage = () => import("@/views/overview/OverviewPage.vue");
const ThemePopulator = () => import("@/components/ThemePopulator.vue");

const section = "business-plan";
const locales = ["en", "cy"];

export const businessPlanChildren = [
  pageRoute({
    path: "",
    name: "BpHome",
    component: HomePage,
    section,
    bodyClass: "home-page",
    title: "Home",
    titleKey: "nav.home",
    locales,
    alias: ["/", "/home"],
    ns: "home",
  }),

  pageRoute({
    path: "foreword",
    name: "BpForeword",
    component: ForewordPage,
    section,
    bodyClass: "foreword",
    title: "Foreword",
    titleKey: "nav.foreword",
    locales,
    alias: ["/foreword"],
    ns: "foreword",
  }),

  pageRoute({
    path: "mission-purpose-and-values",
    name: "BpMission",
    component: MissionPage,
    section,
    bodyClass: "our-mission",
    title: "Our Mission",
    titleKey: "nav.mission",
    locales,
    alias: ["/mission-purpose-and-values"],
    ns: "mission",
  }),

  pageRoute({
    path: "vision",
    name: "BpVision",
    component: VisionPage,
    section,
    bodyClass: "our-vision",
    title: "Our Vision for 2032",
    titleKey: "nav.vision2032",
    locales,
    alias: ["vision"],
    ns: "vision",
  }),

  // ✅ Keep original names to avoid breaking router-link usage
  pageRoute({
    path: "dfc-progress",
    name: "BpDfc",
    component: ThemePopulator,
    section,
    bodyClass: "dfc-branding",
    title: "Delivering for the communities we serve",
    titleKey: "nav.dfc",
    locales,
    alias: ["/dfc-progress"],
    ns: "dfc",
  }),

  pageRoute({
    path: "es-progress",
    name: "BpEs",
    component: ThemePopulator,
    section,
    bodyClass: "es-branding",
    title: "Our progress ensuring sustainability",
    titleKey: "nav.es",
    locales,
    alias: ["/es-progress"],
    ns: "es",
  }),

  pageRoute({
    path: "fftf-progress",
    name: "BpFftf",
    component: ThemePopulator,
    section,
    bodyClass: "fftf-branding",
    title: "Fit for the future",
    titleKey: "nav.fftf",
    locales,
    alias: ["/fftf-progress"],
    ns: "fftf",
  }),

  pageRoute({
    path: "gptw-progress",
    name: "BpGptw",
    component: ThemePopulator,
    section,
    bodyClass: "gptw-branding",
    title: "Create a great place to work",
    titleKey: "nav.gptw",
    locales,
    alias: ["/gptw-progress"],
    ns: "gptw",
  }),

  pageRoute({
    path: "wwo-progress",
    name: "BpWwo",
    component: ThemePopulator,
    section,
    bodyClass: "wwo-branding",
    title: "Our progress working with others",
    titleKey: "nav.wwo",
    locales,
    alias: ["/wwo-progress"],
    ns: "wwo",
  }),

  pageRoute({
    path: "overview",
    name: "BpOverview",
    component: OverviewPage,
    section,
    bodyClass: "overview-branding",
    title: "Our Business Plan at a glance",
    titleKey: "nav.overview",
    locales,
    alias: ["/overview"],
    ns: "overview",
  }),
];
